"use strict";

angular.module('app.directives.sceneRowSmall', [])

    .directive("sceneRowSmall", [
        function () {
            'ngInject';
            
            return {
                restrict: 'A',
                templateUrl: 'views/scene/item_row_small.html',
                scope: {
                    s: '=scene',
                    mode: '=?',
                    sceneList : '=sceneList'
                },

                /* @ngInject */
                controller: function ($scope, $element, $attrs, $state) {

                    switch ($scope.mode) {
                        case "edit":
                            $scope.editmode = true;
                            $scope.sortmode = false;
                            break;
                        case "sort":
                            $scope.editmode = false;
                            $scope.sortmode = true;
                            break;
                        default:
                            $scope.editmode = false;
                            $scope.sortmode = false;
                            break;
                    }

                    $scope.clickScene = function (s) {
                        s.$UI.editMode = false;

                        if ($scope.sortmode) {
                            return false;
                        }
                        if (!$scope.sortmode && !$scope.editmode) {
                            var o= {sceneId: s.SceneId, scene: s};
                            if($scope.sceneList)
                            {
                                o.sceneList = $scope.sceneList.$encode();
                            }

                            $state.go('scene.detail',o );
                        } else {
                            s.$UI.editMode = true;
                        }
                    };

                    $scope.playSceneOnce = function () {
                        $scope.s.$execute();

                    };

                    $scope.EnableDisableScene = function () {
                        $scope.s.$enableDisable();
                    };

                }
            };
        }
    ]);
